module.exports = require("./is-IS.js");